<h1 mat-dialog-title>Alege tipul de acoperiș</h1>
<mat-dialog-content class="mat-typography container">
  <div class="calculation-type-container" *ngFor="let calculation of calculationTypes; let i = index" (click)="redirectToSelected(calculation.roofType, calculation.link)" [mat-dialog-close]="true">
    <img class="image" [src]="calculation.imgLink" [alt]="calculation.title" width="100">
    <div>
      <h1>{{calculation.title}}</h1>
      <p>{{calculation.subText}}</p>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center" class="actions">
  <button mat-flat-button [mat-dialog-close]="true" gaEvent="featured_products_popup_back" gaCategory="buttons_tracking">
    <mat-icon>arrow_backward</mat-icon>
    Închide
  </button>
</mat-dialog-actions>
